import React from "react";
import { ArrowRight, MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BuffalosGreenConnection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="59566" id="pittsburghs-landscape-experts" className="relative w-full overflow-hidden bg-background py-20 lg:py-32 dark">
      {}
      <div className="absolute inset-0 z-0 opacity-[0.05] pointer-events-none text-primary">
        <svg className="h-full w-full" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
          <defs>
            <pattern id="topo-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <path d="M0 100 C 20 0 50 0 100 100 Z" fill="none" stroke="currentColor" strokeWidth="0.5" />
              <path d="M0 50 C 20 0 80 0 100 50 Z" fill="none" stroke="currentColor" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#topo-pattern)" />
        </svg>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div ref={ref} className={`grid gap-12 lg:grid-cols-2 lg:gap-8 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <div className="flex flex-col items-start space-y-6 text-left">
            <Badge variant="outline" className="border-accent/30 bg-accent/10 text-accent px-3 py-1 text-sm font-medium tracking-wide uppercase backdrop-blur-sm">
              <MapPin className="mr-1 h-3 w-3" />
              Serving Pittsburgh & Surrounding Areas
            </Badge>

            <h1 className="font-serif text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl lg:text-7xl lg:leading-[1.1]">
              Professional <br />
              <span className="text-primary">Landscaping Services</span>
            </h1>

            <p className="max-w-[600px] font-sans text-lg text-muted-foreground md:text-xl leading-relaxed">
              Nieser Landscaping brings over 40 years of local expertise to your 
              outdoor spaces. We provide reliable, high-quality landscape design 
              and maintenance for homeowners across Pittsburgh.
            </p>

            <div className="flex flex-col gap-4 sm:flex-row pt-4">
              <Button asChild size="lg" className="group relative overflow-hidden bg-primary text-primary-foreground hover:bg-primary/90 shadow-lg shadow-primary/20 transition-all hover:shadow-xl hover:shadow-primary/30">
                <Link to="/GetAnEstimatePage">
                  <span className="relative z-10 flex items-center gap-2">
                    Request a Free Estimate
                    <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                  </span>
                  {}
                  <span className="absolute inset-0 z-0 animate-pulse bg-white/10 opacity-0 group-hover:opacity-100" />
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="border-accent/40 text-accent hover:bg-accent/10 hover:text-accent shadow-sm">
                <Link to="tel:4127588781">Call Now: (412) 758-8781</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative mx-auto w-full max-w-[600px] lg:max-w-none">
            <div className="relative aspect-[4/3] w-full overflow-hidden lg:aspect-square">
              {}
              <div className="absolute -right-10 -top-10 h-64 w-64 rounded-full bg-accent/20 blur-3xl filter" />
              <div className="absolute -bottom-10 -left-10 h-64 w-64 rounded-full bg-primary/20 blur-3xl filter" />

              {}
              <div className="relative h-full w-full overflow-hidden rounded-[2rem] lg:rounded-[30%_70%_70%_30%_/_30%_30%_70%_70%] shadow-2xl shadow-primary/20 transition-all duration-500 hover:scale-[1.02]">
                <div className="absolute inset-0 bg-gradient-to-t from-primary/40 to-transparent z-10" />
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586632/img/buffalo_perennial_garden.png" alt="Professionally landscaped Pittsburgh estate" className="h-full w-full object-cover object-center" />
              </div>

              {}
              <div className="absolute -bottom-6 -left-6 z-20 hidden md:block">
                <div className="flex items-center gap-4 rounded-xl border border-border bg-card/90 p-4 shadow-xl backdrop-blur-md">
                  <div className="flex -space-x-3">
                    {[1, 2, 3].map(i => <div key={i} data-index={i} className="h-10 w-10 rounded-full border-2 border-primary bg-muted overflow-hidden">
                        <img src={`/img/gardener_avatar_${i}.png`} alt="Landscape Expert" className="h-full w-full object-cover" />
                      </div>)}
                  </div>
                  <div className="text-sm">
                    <p className="font-bold text-foreground">40+ Years Experience</p>
                    <p className="text-xs text-muted-foreground font-sans">
                      Trusted by Pittsburgh Homeowners
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}